// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"c3393065","83":"8b719ccb","183":"63de20d7","715":"cc21d1f0","801":"aed5a235"}[chunkId] + ".css";
};